//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'

export default {
  setup() {
    const radioGroup = ref(1)
    const rules = [value => (value !== 3 ? true : 'Do not select the third one!')]

    return { radioGroup, rules }
  },
}
